window.MMUPSELL = window.MMUPSELL || {};

(function () {
  const SECTION_KEYS = ["cart-drawer", "cart-icon-bubble", "main-cart-items"];

  const state = {
    isAddingUpsell: false,
    networkWrapped: false,
  };

  function safeUrl(input) {
    try {
      if (typeof input === "string") return input;
      if (input && typeof input.url === "string") return input.url;
      return "";
    } catch {
      return "";
    }
  }

  function isCartPath() {
    const p = (window.location.pathname || "").toLowerCase();
    return p === "/cart" || p.endsWith("/cart");
  }

  async function fetchCart() {
    const res = await fetch("/cart.js", {
      method: "GET",
      credentials: "same-origin",
      headers: { Accept: "application/json" },
    });
    return await res.json();
  }

  function normalizeVariantId(v) {
    const n = Number(v);
    return Number.isFinite(n) && n > 0 ? n : null;
  }

  function getUpsellVariantIds(popups) {
    return popups.map((p) => normalizeVariantId(p.dataset.variant)).filter(Boolean);
  }

  function cartHasAnyOfVariants(cart, variantIds) {
    if (!cart || !Array.isArray(cart.items) || !variantIds.length) return false;
    const set = new Set(variantIds.map(Number));
    return cart.items.some((it) => set.has(Number(it.variant_id)));
  }

  function updateCartBubbleFallback(cart) {
    try {
      const count = cart && typeof cart.item_count === "number" ? cart.item_count : null;
      if (count === null) return;

      const el = document.querySelector("[data-cart-count], .cart-count-bubble");
      if (!el) return;

      const target = el.querySelector("[data-cart-count]") || el.querySelector("span") || el;
      target.textContent = String(count);

      if (count <= 0) el.setAttribute("hidden", "hidden");
      else el.removeAttribute("hidden");
    } catch (e) {
      console.error("updateCartBubbleFallback error:", e);
    }
  }

  function findInSectionHTML(html, selectors) {
    const tmp = document.createElement("div");
    tmp.innerHTML = html;
    for (const sel of selectors) {
      const node = tmp.querySelector(sel);
      if (node) return node;
    }
    return null;
  }

  function replaceNode(target, replacement) {
    if (!target || !replacement) return false;
    try {
      target.replaceWith(replacement);
      return true;
    } catch (e) {
      console.error("replaceNode error:", e);
      return false;
    }
  }

  async function refreshCartSections() {
    const url = `${window.location.pathname}?sections=${SECTION_KEYS.join(",")}`;

    try {
      const res = await fetch(url, { credentials: "same-origin" });
      const data = await res.json();

      if (data["cart-drawer"]) {
        const drawerSelectors = [
          "#CartDrawer",
          "cart-drawer",
          '[data-drawer="cart"]',
          "[data-cart-drawer]",
          '[data-section-type="cart-drawer"]',
        ];

        const newDrawer = findInSectionHTML(data["cart-drawer"], drawerSelectors);
        const currentDrawer = drawerSelectors.map((s) => document.querySelector(s)).find(Boolean);

        if (newDrawer && currentDrawer) replaceNode(currentDrawer, newDrawer);
      }

      if (data["cart-icon-bubble"]) {
        const bubbleSelectors = ["[data-cart-count]", ".cart-count-bubble"];
        const newBubble = findInSectionHTML(data["cart-icon-bubble"], bubbleSelectors);
        const currentBubble = bubbleSelectors.map((s) => document.querySelector(s)).find(Boolean);

        if (newBubble && currentBubble) currentBubble.innerHTML = newBubble.innerHTML;
      }

      if (data["main-cart-items"]) {
        const candidates = [
          "#main-cart-items",
          "#MainCartItems",
          "[data-main-cart-items]",
          ".cart__items",
          ".cart-items",
        ];
        const newMain = findInSectionHTML(data["main-cart-items"], candidates);
        const currentMain = candidates.map((s) => document.querySelector(s)).find(Boolean);

        if (newMain && currentMain) currentMain.innerHTML = newMain.innerHTML;
      }

      try {
        const cart = await fetchCart();
        updateCartBubbleFallback(cart);
      } catch {}
    } catch (err) {
      console.error("refreshCartSections error:", err);
      try {
        const cart = await fetchCart();
        updateCartBubbleFallback(cart);
      } catch {}
    }
  }

  window.MMUPSELL.refreshCartSections = refreshCartSections;

  function triggerUpsellSoon() {
    setTimeout(() => {
      try {
        document.dispatchEvent(new CustomEvent("mm:start-upsell"));
      } catch (e) {
        console.error("mm:start-upsell dispatch error:", e);
      }
    }, 150);
  }

  function wrapNetworkForAutoTrigger() {
    if (state.networkWrapped) return;
    state.networkWrapped = true;

    const originalFetch = window.fetch.bind(window);
    window.fetch = async (...args) => {
      const url = safeUrl(args[0]);
      const res = await originalFetch(...args);

      try {
        if (
          !state.isAddingUpsell &&
          res &&
          res.ok &&
          (url.includes("/cart/add") || url.includes("/cart/change") || url.includes("/cart/update"))
        ) {
          triggerUpsellSoon();
        }
      } catch (e) {
        console.error("fetch wrapper error:", e);
      }

      return res;
    };

    const originalOpen = XMLHttpRequest.prototype.open;
    const originalSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url, ...rest) {
      this.__mm_url = typeof url === "string" ? url : "";
      return originalOpen.call(this, method, url, ...rest);
    };

    XMLHttpRequest.prototype.send = function (body) {
      try {
        this.addEventListener("load", () => {
          const url = this.__mm_url || "";
          if (
            !state.isAddingUpsell &&
            this.status >= 200 &&
            this.status < 300 &&
            (url.includes("/cart/add") || url.includes("/cart/change") || url.includes("/cart/update"))
          ) {
            triggerUpsellSoon();
          }
        });
      } catch (e) {
        console.error("xhr wrapper error:", e);
      }

      return originalSend.call(this, body);
    };
  }

  function wireFormSubmitAutoTrigger() {
    document.addEventListener(
      "submit",
      (e) => {
        const form = e.target;
        if (!form || form.tagName !== "FORM") return;

        const action = (form.getAttribute("action") || "").toLowerCase();
        if (action.includes("/cart/add")) {
          triggerUpsellSoon();
        }
      },
      true
    );
  }

  document.addEventListener("DOMContentLoaded", function () {
    wrapNetworkForAutoTrigger();
    wireFormSubmitAutoTrigger();

    const popups = Array.from(document.querySelectorAll(".mm-cart-upsell-popup"));
    if (!popups.length) return;

    const upsellVariantIds = getUpsellVariantIds(popups);

    function wireClose(popup) {
      function closeUpsell() {
        popup.style.display = "none";
        document.dispatchEvent(new CustomEvent("mm:upsell-closed"));
      }

      const closeBtn = popup.querySelector(".mm-upsell-close");
      const declineBtn = popup.querySelector(".mm-upsell-decline");
      if (closeBtn) closeBtn.onclick = closeUpsell;
      if (declineBtn) declineBtn.onclick = closeUpsell;
    }

    function wireAdd(popup, variantId) {
      const addBtn = popup.querySelector('[data-mm-upsell-add] .button, [data-mm-upsell-add] button, [data-mm-upsell-add] a.button');
      if (!addBtn) return;

      addBtn.onclick = async (e) => {
        if (e && typeof e.preventDefault === "function") e.preventDefault();

        try {
          state.isAddingUpsell = true;

          const res = await fetch("/cart/add.js", {
            method: "POST",
            credentials: "same-origin",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              "X-Requested-With": "XMLHttpRequest",
            },
            body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
          });

          if (!res.ok) {
            let msg = "Upsell add failed.";
            try {
              const err = await res.json();
              if (err && err.description) msg = err.description;
            } catch {}
            console.error(msg);
            return;
          }

          popups.forEach((p) => {
            p.style.display = "none";
            p.dataset.disabled = "true";
          });

          sessionStorage.setItem("mm_upsell_seen", "true");

          if (isCartPath()) {
            window.location.reload();
            return;
          }

          await refreshCartSections();

          try {
            const cart = await fetchCart();
            updateCartBubbleFallback(cart);
          } catch {}

          document.dispatchEvent(new CustomEvent("mm:upsell-closed"));
        } finally {
          state.isAddingUpsell = false;
        }
      };
    }

    popups.forEach((p) => wireClose(p));

    async function showUpsellOnce() {
      if (sessionStorage.getItem("mm_upsell_seen") === "true") return;

      let cart;
      try {
        cart = await fetchCart();
      } catch (e) {
        console.error("fetchCart error:", e);
        return;
      }

      if (!cart || !Array.isArray(cart.items) || cart.items.length === 0) return;

      if (cartHasAnyOfVariants(cart, upsellVariantIds)) {
        popups.forEach((p) => (p.dataset.disabled = "true"));
        sessionStorage.setItem("mm_upsell_seen", "true");
        return;
      }

      const eligible = popups.filter((p) => p.dataset.disabled !== "true" && normalizeVariantId(p.dataset.variant));
      if (!eligible.length) return;

      const popup = eligible[Math.floor(Math.random() * eligible.length)];
      const variantId = normalizeVariantId(popup.dataset.variant);
      const delay = parseInt(popup.dataset.delay, 10) || 3000;

      wireAdd(popup, variantId);

      setTimeout(async () => {
        if (sessionStorage.getItem("mm_upsell_seen") === "true") return;

        let cartBeforeShow;
        try {
          cartBeforeShow = await fetchCart();
        } catch (e) {
          console.error("fetchCart error:", e);
          return;
        }

        if (!cartBeforeShow || !Array.isArray(cartBeforeShow.items) || cartBeforeShow.items.length === 0) return;

        if (cartHasAnyOfVariants(cartBeforeShow, upsellVariantIds)) {
          popups.forEach((p) => (p.dataset.disabled = "true"));
          sessionStorage.setItem("mm_upsell_seen", "true");
          return;
        }

        popup.style.display = "flex";
        sessionStorage.setItem("mm_upsell_seen", "true");
      }, delay);
    }

    document.addEventListener("mm:start-upsell", () => {
      showUpsellOnce();
    });

    if (isCartPath()) showUpsellOnce();
    window.addEventListener("pageshow", () => {
      if (isCartPath()) showUpsellOnce();
    });
  });
})();
